import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
    marginBottom: 10,
  },
  chip: {
    marginRight: 3,
    marginBottom: 3,
  },
});
